import { TablePagination } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setShoopyStoresCurrentPage,
  setShoopyStoresMaxPageSoFar,
  setShoopyStoresPerPage,
} from "../../../redux/shoopystores/shoopyStoreActions";
import { fetchShoopyStores } from "../../../redux/shoopystores/shoopyStoreActions";
import { SHOOPY_STORES_PER_PAGE } from "../../../utils/utils";

const StoreTablePagination = ({ paginationArray }) => {
  const dispatch = useDispatch();
  const storeState = useSelector((state) => state.shoopystores);
  const {
    numberOfElements,
    storesPerPage,
    currentPage,
    maxPageSoFar,
    searchKey,
  } = storeState;

  //  pagination action
  const handleChangeStoresPerPage = (event) => {
    dispatch(setShoopyStoresCurrentPage(0));
    dispatch(setShoopyStoresMaxPageSoFar(0));
    dispatch(setShoopyStoresPerPage(parseInt(event.target.value, 10)));
    dispatch(fetchShoopyStores(0, searchKey, parseInt(event.target.value, 10)));
  };

  const handleChangePage = (event, newPage) => {
    console.log("newPage", newPage);

    if (newPage > currentPage) {
      // Next page
      if (maxPageSoFar < newPage) {
        dispatch(fetchShoopyStores(newPage, searchKey, storesPerPage));
        dispatch(
          setShoopyStoresMaxPageSoFar(
            maxPageSoFar < newPage ? newPage : maxPageSoFar
          )
        );
        dispatch(setShoopyStoresCurrentPage(newPage));
      } else {
        dispatch(setShoopyStoresCurrentPage(newPage));
      }
    } else {
      // Previous page
      dispatch(setShoopyStoresCurrentPage(newPage));
    }
  };

  return (
    <div>
      <TablePagination
        rowsPerPageOptions={
          paginationArray ?? [SHOOPY_STORES_PER_PAGE, 20, 30, 50, 100]
        }
        component="div"
        count={numberOfElements}
        rowsPerPage={storesPerPage}
        page={currentPage}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeStoresPerPage}
      />
    </div>
  );
};

export default StoreTablePagination;
